import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";

const Search: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  function onChange(data: any) {
    const value = data.target.value;

    searchParams.set('term',  value);
    setSearchParams(searchParams, { replace: true });
  }

  return (
    <div className='v-filter__search'>
      <Input
        onChange={onChange}
        defaultValue={searchParams.get('term') || ''}
        allowClear
        placeholder="Search text"
        suffix={<SearchOutlined />}
      />
    </div>
  );
}

export default Search;
